import React from 'react';
import socialLinks from './social/data';
import CardGrid from './social/cardGrid';

const Social = () => {
  return (
    <div id="social" className="min-h-screen flex items-center justify-center p-4 sm:p-8">
      <div className="max-w-5xl w-full">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4
            bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 
            bg-clip-text text-transparent">
            Let's Connect
          </h2>
          <p className="text-neutral-600 dark:text-neutral-400 text-lg mb-12">
            Find me on these platforms
          </p>
        <CardGrid socialLinks={socialLinks} />
        </div>
      </div>
    </div>
  );
};

export default Social;